import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';

export const DCPDFButton = () => {
    return (
        <Button variant="outline" size="sm" onClick={() => window.print()}>
            <Printer className="w-4 h-4 mr-2" />
            Print / Download PDF
        </Button>
    );
};
